import {Component, inject, OnInit} from '@angular/core';
import { RouterModule } from '@angular/router';
import {ThemeToggleButtonComponent} from '../../../shared/components/theme-toggle/theme-toggle-button.component';
import {Meta, Title} from '@angular/platform-browser';

@Component({
  selector: 'app-not-found',
  imports: [
    RouterModule,
    ThemeToggleButtonComponent,
  ],
  templateUrl: './not-found.component.html',
  styles: ``
})
export class NotFoundComponent implements OnInit{

  private readonly title = inject(Title);
  private readonly meta = inject(Meta);

  currentYear: number = new Date().getFullYear();

  ngOnInit(): void {
    this.title.setTitle('404 - Page Not Found');
    this.meta.updateTag({ name: 'robots', content: 'noindex' });
  }
}
